"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletData = void 0;
const react_1 = __importDefault(require("react"));
const useNetwork_1 = require("./useNetwork");
const connect_button_1 = require("@soroban-react/connect-button");
// TODO: Eliminate flash of unconnected content on loading
function WalletData({ sorobanContext }) {
    var _a;
    const useAccount = () => {
        const { address } = sorobanContext;
        if (!address) {
            return {};
        }
        return {
            data: {
                address,
                displayName: `${address.slice(0, 4)}...${address.slice(-4)}`,
            }
        };
    };
    const { data: account } = useAccount();
    const { activeChain: chain, chains } = (0, useNetwork_1.useNetwork)(sorobanContext);
    const unsupportedChain = chain === null || chain === void 0 ? void 0 : chain.unsupported;
    const styleDisplayData = { display: "flex" };
    return (react_1.default.createElement(react_1.default.Fragment, null, account ? (react_1.default.createElement("div", { className: styleDisplayData },
        chain && (chains.length > 1 || unsupportedChain) && (react_1.default.createElement("div", null,
            chain.iconUrl, (_a = chain.name) !== null && _a !== void 0 ? _a : chain.id)),
        react_1.default.createElement("div", null, account.displayName))) : (react_1.default.createElement(connect_button_1.ConnectButton, { label: "Connect Wallet", sorobanContext: sorobanContext }))));
}
exports.WalletData = WalletData;
